import React from "react";
import styled from "styled-components";
import Container from "../Container";

const Wrap = styled.div`
  height: 4rem;
  display: flex;
  align-items: center;
  background-color: #172a67;
  text-align: center;
`;

export default ({ children }) => (
  <Wrap>
    <Container>
      <div className="flex items-center">
        <div className="center white">{children}</div>
      </div>
    </Container>
  </Wrap>
);



// WEBPACK FOOTER //
// ./src/components/generic/layout/Offer/index.js